import {AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort, Sort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {SelectionModel} from "@angular/cdk/collections";
import {faCogs, faPlugCircleCheck} from "@fortawesome/free-solid-svg-icons";
import {MapInfoWindow} from "@angular/google-maps";
import {timeout} from "../../../decorators/timeout";
import {Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";
import {BehaviorSubject, Observable} from "rxjs";
import {faFirefox} from "@fortawesome/free-brands-svg-icons";
import {SceneCreateWizardComponent} from "../scene-create-wizard/scene-create-wizard.component";
import {Compbaser} from "../../../components/compbaser";
import {SceneMimeTypes} from "../scene-blocks/mime-constants";
import {DialogPopComponent} from "../../../components/dialog-pop/dialog-pop.component";
import {IDialogGetAsset} from "../../../components/dialog-get-asset/dialog-get-asset.component";
import {DialogClipboardComponent} from "../../../components/dialog-clipboard/dialog-clipboard.component";
import {
    EnumWizardUpgradeToasts,
    ExperienceLevelType,
    IAccessTable,
    ICommon,
    ICRUDCommand,
    ICRUDRecord,
    Id,
    IPage,
    IPager,
    IPlayerProps,
    ISceneBlock,
    ISceneTreeSearchResult,
    ISceneTreeSliceResults,
    IStationData,
    IUser
} from "../../../interfaces";
import {getPlayerIdInScene, getPlayerIdsOfSceneId, isMimeTypeExists, isSceneEmbedded, LargePageSizeOptions, preprocessSceneRecord, PREVIOUSLY_USED_ACCOUNT} from "../../../common";
import {actionAddScene, actionCRUDRecord, actionRemoveSceneBlocks, actionRemoveScenes, actionUpdateSceneItem} from "../../../store/actions/user.actions";
import {AccessService, AppService, CommonService, ContainerService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {MatTabChangeEvent} from "@angular/material/tabs";
import * as _ from "lodash";
import {Lib} from "../../../../libs/Lib";
import {SceneListService} from "../../../services/scene-list.service";

enum EnumConnectionType {
    ALL,
    REGULAR,
    SPECIALIZED
}

@Component({
    selector: 'app-scene-list-details',
    templateUrl: './scene-list-details.component.html',
    styleUrls: ['./scene-list-details.component.scss']
})

export class SceneListDetailsComponent extends Compbaser implements OnInit, AfterViewChecked {

    @ViewChild('addBlackScene', {read: TemplateRef}) addBlackScene: TemplateRef<any>;
    @ViewChild('firefoxModal', {read: TemplateRef}) firefoxModal: TemplateRef<any>;
    @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    @Input() dialogGetAsset: IDialogGetAsset;

    @Input()
    set filterByType(i_value: boolean) {
        this.m_filterByType = i_value;
    }

    @Output() itemSelected = new EventEmitter<number>();
    @Output() toggleMinimize = new EventEmitter<any>();
    @Output() btnClick = new EventEmitter();

    readonly faFirefox = faFirefox;
    readonly pageSizeOptions = LargePageSizeOptions;

    m_stations: Array<IStationData>;
    pageSize = 10;
    pageIndex = 0;
    hidePageSize = false;
    selectedTabIndex = 0;
    allowMultiSelect = true;
    highlightedRows = [];
    m_EnumConnectionType = EnumConnectionType;
    m_EnumConnectionSelected = EnumConnectionType.ALL;
    globalFilter = '';
    columnFilter = {
        tree_path: ''
    };
    faPlugCircleCheck = faPlugCircleCheck;
    faCogs = faCogs;
    categories: Array<string> = [];
    m_filterByType: boolean;
    dataSource: MatTableDataSource<any>;
    displayedColumns: string[] = ['select', 'icon', 'label', 'modified', 'type', 'playerAssignable', 'category', 'id', 'items'];
    selection: SelectionModel<string>;
    exclusiveMimeType: string; // filter by specific mime type
    sceneId: Id;
    sceneItemId: Id;
    markedRowId: Id;
    activeSort;
    isFullFeatures;
    scenes: IPlayerProps[] = [];
    lastGetTime;
    activeModal;
    newSceneSettings = {width: 1920, height: 1080, name: 'new scene'};
    accountInitialCopyResources;
    PREVIOUSLY_USED_ACCOUNT = PREVIOUSLY_USED_ACCOUNT;
    groupsAccessTable$: Observable<IAccessTable>;
    stringJSPipeArgs = {toDateFromTimestamp: ['MM/DD/YY H:mm']};
    stringJSPipeJson = {replace: ['Json.', '']};
    stringJSPipeJson2 = {replace: ['.', ' ']};
    dataSourcePreviewList$: BehaviorSubject<any[]>;
    m_user: IUser;

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    constructor(public storeSelector: StoreSelectorsService,
                public router: Router,
                protected override dialog: MatDialog,
                public cdr: ChangeDetectorRef,
                private accessService: AccessService,
                private localStoreService: LocalStoreService,
                private translocoService: TranslocoService,
                private toastr: ToastrService,
                private sceneListService: SceneListService,
                private containerService: ContainerService,
                private commonService: CommonService,
                private appService: AppService) {
        super();
    }

    ngOnInit() {
        const initialSelection = [];
        this.groupsAccessTable$ = this.accessService.getGroupsTable('SignStudio Editor', "player_data");
        this.pageSize = parseInt(this.localStoreService.getStorageValConfig('pageSize')) || 10;
        this.globalFilter = this.localStoreService.getStorageValConfig('sceneFilter');
        this.columnFilter.tree_path = this.localStoreService.getStorageValConfig('sceneCategory');
        this.accountInitialCopyResources = this.localStoreService.getStorageConfig().accountInitialCopyResources;

        if (this.dialogGetAsset) {
            this.allowMultiSelect = this.dialogGetAsset.multiSelect;
            if (!this.dialogGetAsset.multiSelect) {
                this.displayedColumns.shift();
            }
            this.exclusiveMimeType = this.dialogGetAsset.mimeType;
            if (_.isEmpty(this.exclusiveMimeType)) {
                this.m_EnumConnectionSelected = EnumConnectionType.ALL;
            }
        }
        this.selection = new SelectionModel<string>(this.allowMultiSelect, initialSelection);
        this.cod(
            this.storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.m_user = user;
                })
        );
        this.cod(
            this.storeSelector.getLastGetTime()
                .subscribe((v) => {
                    this.lastGetTime = v;
                })
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            })
        );
        this.cod(
            this.storeSelector.listenSelectedSceneIdAndSceneItemId().subscribe((v) => {
                this.sceneId = v.sceneId;
                this.sceneItemId = v.sceneItemId;
            })
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates()
                .subscribe((updates) => {
                    this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
                    if (!updates) return;
                    this.accountInitialCopyResources = this.localStoreService.getStorageValConfig('accountInitialCopyResources');
                    setTimeout(() => {
                        if (this.accountInitialCopyResources == PREVIOUSLY_USED_ACCOUNT) {
                            if (this.dataSource && this.sort && this.paginator) {
                                this.dataSource.sort = this.sort;
                                this.dataSource.paginator = this.paginator;
                                this.cdr.detectChanges();
                            }
                        }
                    }, 100);
                })
        );
        this.cod(
            this.containerService.getMarkedTableRow().subscribe((_id) => {
                if (_id) this.markedRowId = _id;
                setTimeout(() => {
                    this.markedRowId = '';
                }, 500);
            })
        );
        this.resetTableSelection();
        this.updateDataSource();

        // this.cod(
        //     this.storeSelector.isFirefox().subscribe((v) => {
        //         if (!v) return;
        //         setTimeout(() => {
        //             this.dialog.open(this.firefoxModal, {
        //                 width: '400px',
        //                 height: '300px'
        //             });
        //         }, 3000);
        //     })
        // );
        this.cod(
            this.storeSelector.getStationsComplete()
                .subscribe((v) => {
                    this.m_stations = v || [];
                })
        );

        this.cod(
            this.sceneListService.selectedChanged$.subscribe( sceneIds => {
                this.clearSelection();
                this.selection.clear();
                this.selection.select(...sceneIds as string[]);


                this.sort.active = 'select';
                this.sort.direction = 'desc';
                this.sort.sortChange.emit({ active: this.sort.active, direction: this.sort.direction });
            })
        );

        this.cod(
            this.sceneListService.deleteSelected$.subscribe( sceneIds => {
                
                this.onDelete();
            })
        );

    }

    ngAfterViewChecked(): void {
    }

    private resetTableSelection() {
        const tblSelection = this.containerService.getTableSelection('scenes');
        if (tblSelection) {
            // reset table pagination
            if (tblSelection['pageIndex']) this.pageIndex = tblSelection['pageIndex'];

            // reset table sort
            if (tblSelection['sort']) {
                this.activeSort = tblSelection['sort'];
            }

            // reset selection model
            // if (tblSelection['selectedModel'] && tblSelection['selectedModel'].length > 0) {
            //     this.selection.clear();
            //     setTimeout(() => {
            //         tblSelection['selectedModel'].forEach((s) => {
            //             this.selection.select(s);
            //         });
            //     }, 500);
            // }
        }
    }

    onFilterSelection(e) {
        this.selection.clear();
        this.m_EnumConnectionSelected = e.value[0];
        this.updateDataSource();
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        if (this.dataSource) {
            const numSelected = this.selection.selected.length;
            const pageSize = this.dataSource.paginator.pageSize;
            if (numSelected >= pageSize) {
                return true;
            } else {
                if (this.dataSource.filteredData.length > pageSize) {
                    return false;
                } else {
                    return this.dataSource.filteredData.length === numSelected;
                }
            }
        }
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        if (!this.dataSource) return;

        debugger
        if (this.isAllSelected()) {
            this.selection.clear();
        } else {
            const pageIndex = this.dataSource.paginator.pageIndex;
            const pageSize = this.dataSource.paginator.pageSize;
            let endIndex: number;
            if (this.dataSource.filteredData.length > (pageIndex + 1) * pageSize) {
                endIndex = (pageIndex + 1) * pageSize;
            } else {
                endIndex = this.dataSource.filteredData.length;
            }

            for (let index = (pageIndex * pageSize); index < endIndex; index++) {
                this.selection.select(this.dataSource.filteredData[index].Player.$.id as any);
            }
        }
    }

    onDeselect() {
        this.selection.clear();
    }

    @timeout(10)
    updateDataSource() {
        let source: Array<IPlayerProps> = [];
        this.getSceneCategories();
        this.cod(
            this.storeSelector.getScenes(null, false)
                .subscribe((i_scenes) => {
                    // const sortedByModified = i_scenes.sort((a, b) => {
                    //     if (b.Player.$.lastModified) {
                    //         if (a.Player.$.lastModified && b.Player.$.lastModified) {
                    //             return parseInt(b.Player.$.lastModified) - parseInt(a.Player.$.lastModified);
                    //         }
                    //         return 1;
                    //     }
                    //     return -1;
                    // });

                    this.scenes = i_scenes;
                    source = i_scenes.filter((i_scene) => {
                        if (i_scene.Player.$.id === this.sceneId) {
                            return this.dialogGetAsset.includeSelf;
                            // if (isSceneDesktopEmpty(i_scene))
                            //     return false;
                        }

                        switch (this.m_EnumConnectionSelected) {
                            case EnumConnectionType.ALL: {
                                return true;
                            }
                            case EnumConnectionType.REGULAR: {
                                return this.storeSelector.isMainSceneOrPlayer(i_scene.Player.$.mimeType) || i_scene.Player.$.mimeType.length === 0;
                            }
                            case EnumConnectionType.SPECIALIZED: {
                                return i_scene.Player?.$?.mimeType?.length > 0 && i_scene.Player.$.mimeType !== SceneMimeTypes.Player && i_scene.Player.$.mimeType !== SceneMimeTypes.Scene;
                            }
                        }
                    });

                    /**
                     if we want to filter the scenes by an additional passed in to dialog mimeType, if the passed in is of 'scene' or 'mainPlayer'
                     we check against both possibilities to know if to show the scene in the list or not, if it's not 'scene' or 'mainPlayer' that
                     was passed in, we just use standard findIndex to filter by a match.
                     **/
                    if (this.exclusiveMimeType) {
                        // const blockLabelProp: IBlockLabelProp = this.storeSelector.getBlockLabelByJsonType(this.exclusiveMimeType);
                        source = source.filter((value) => {
                            if (this.storeSelector.isMainSceneOrPlayer(this.exclusiveMimeType)) {
                                switch (this.dialogGetAsset.mode) {
                                    case "SCENE:PLAYER_ASSIGNABLE": {
                                        return this.storeSelector.isMainScenePlayerOnly(value.Player.$.mimeType);
                                    }
                                    default: {
                                        return this.storeSelector.isMainSceneOrPlayer(value.Player.$.mimeType);
                                    }
                                }
                            } else {
                                return isMimeTypeExists([this.exclusiveMimeType], value.Player.$.mimeType);
                            }
                        });
                    }
                    this.applyTableCustomization(source);
                    if (this.globalFilter || this.columnFilter.tree_path) this.applyFilter(this.globalFilter);
                })
        );
    }

    onCategoryChange(val) {
        this.columnFilter.tree_path = val ? val : '';
        this.localStoreService.setStorageValConfig('sceneCategory', this.columnFilter.tree_path);
        if (this.dataSource) this.dataSource.filter = JSON.stringify(this.columnFilter);
    }

    applyFilter(filterValue: string) {
        this.localStoreService.setStorageValConfig('sceneFilter', filterValue);
        if (this.dataSource) this.dataSource.filter = JSON.stringify(this.columnFilter);
    }

    applyTableCustomization(sources) {
        this.dataSource = new MatTableDataSource(sources);
        this.dataSource.paginator = this.paginator;

        this.dataSource.filterPredicate = this.customFilterPredicate();
        // this.dataSource.filterPredicate = (data: any, filter) => {
        //     const dataStr = JSON.stringify(data).toLowerCase();
        //     return dataStr.indexOf(filter) !== -1;
        // };



        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (item: IPlayerProps, property) => {
            switch (property) {
                case 'select':
                    const id = item.Player.$.id;
                    const sceneIds = this.selection.selected.map((sceneId) => String(sceneId));
                    return sceneIds.includes(id) ? '1' : '0';
                case 'items':
                    return item.Player?.Data[0]?.Scene[0]?.Players[0]?.Player?.length;
                case 'type':
                    return item.Player.$.mimeType;
                case 'modified':
                    return item.Player.$.lastModified;
                case 'id':
                case 'label':
                    return item.Player.$[property];
                case 'category':
                    return item.Player?.$?.folder;
                default: {
                    return item[property];
                }
            }
        };

        if (this.activeSort) {
            const sortState: Sort = this.activeSort;
            this.sort.active = this.activeSort.active;
            this.sort.direction = this.activeSort.direction;
            this.sort.sortChange.emit(sortState);
            // this.cdr.detectChanges();
            // this.sort.sort((this.activeSort) as MatSortable);
        }
        if (this.dataSource) {
            this.dataSourcePreviewList$ = this.dataSource.connect();
        }
    }

    createBlankScene() {
        this.activeModal.close();
        const sceneId = _.uniqueId();
        const sceneBlock = this.storeSelector.getBlockLabelByFileType('scene');
        const scene: ISceneBlock = sceneBlock.template;
        const newScene = {Player: scene};

        // set scene layout
        newScene.Player.$.id = sceneId;
        newScene.Player.$.player = sceneBlock.id;
        newScene.Player.Data[0].Layout[0].$.width = this.newSceneSettings.width + '';
        newScene.Player.Data[0].Layout[0].$.height = this.newSceneSettings.height + '';
        newScene.Player.$.label = this.newSceneSettings.name;
        newScene.Player.$.mimeType = SceneMimeTypes.Player;
        this.createScene(newScene);
    }

    openBlankSceneDialog() {
        this.activeModal = this.dialog.open(this.addBlackScene);
    }

    addWizard() {
        // Test user enterprise
        // this.dialog.open(UserEnterpriseComponent, {
        //     width: '1000px',
        //     data: {}
        // });
        const dialogRef = this.dialog.open(SceneCreateWizardComponent, {
            width: '1200px',
            data: {}
        });
        dialogRef.afterClosed().subscribe((newScene) => {
            if (newScene) {
                this.createScene(newScene);
            }
        });
    }

    addSceneFromTemplate() {
        this.router.navigate([`/editor/new`]);
    }

    createScene(newScene) {
        /** CRUD create the new scene **/
        const saveRecord = preprocessSceneRecord(newScene, null, this.localStoreService.getStorageConfig().studioId, 'add');
        /** create scene and get inserted id */
        this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
            if (!i_crudReply.serverReply.status) {
                this.toastr.error(this.translocoService.translate('toast.failedCreateScene', {}, this.translocoService.getActiveLang()));
                return;
            }

            // change scene player id
            const newPlayerId = String(i_crudReply.serverReply.id);
            newScene.Player.$.id = newPlayerId;
            newScene.Player.$.lastModified = new Date().getTime();
            newScene.Player.$.changelist_id = String(i_crudReply.serverReply.changelist_id);
            this.storeSelector.dispatch(actionAddScene({player: newScene}));

            const saveRecord2 = preprocessSceneRecord(newScene, null, this.localStoreService.getStorageConfig().studioId, 'add');
            this.crudScene('update', newPlayerId, {player_data_value: saveRecord2.body.player_data_value});
            this.router.navigateByUrl(`editor/scene/${newPlayerId}`);
        });

    }

    onDelete() {
        // if (!this.accessConfig.del) return this.accessService.showNoAccess();
        if (this.selection.selected.length === 0) return this.toastr.error(this.translocoService.translate('toast.noSceneRemSel', {}, this.translocoService.getActiveLang()));
        const localRemText1 = this.translocoService.translate('general.removeScenes2', {}, this.translocoService.getActiveLang());
        const localRemText2 = this.translocoService.translate('general.scenes', {}, this.translocoService.getActiveLang());

        // check if the scene is assigned to player.
        const isPlayerAssignedScene = this.checkScenesUsedInPlayer();
        if (isPlayerAssignedScene) {
            this.dialog.open(DialogPopComponent, {
                height: '200px',
                width: '400px',
                data: {name: this.translocoService.translate('toast.notAllowedToRemoveAssignedScene', {}, this.translocoService.getActiveLang()), showCancel: false}
            });
        } else {
            const dialogRef = this.dialog.open(DialogPopComponent, {
                height: '200px',
                width: '400px',
                data: {name: `${localRemText1} [ ${this.selection.selected.length} ] ${localRemText2}?`, showCancel: true}
            });
            dialogRef.afterClosed().subscribe((r) => {
                if (r) {
                    // this.removeScenesUsedInLocationScenes('GPS');
                    // this.removeScenesUsedInLocationScenes('Fixed');
                    // this.removeScenesUsedInPlaylistScenes();

                    this.removeScenesUsedInScenes();
                    this.removeScenesUsedInScheduler();
                    this.removeScenes(true);
                    this.resetSelection();
                }
            });
        }
    }

    private checkScenesUsedInPlayer() : boolean {
        let isAssigned = false;
        this.selection.selected.forEach((sceneId) => {
            if (isAssigned) return;
            if (this.m_stations.find(e => e.props.player_data_id == sceneId)) {
                isAssigned = true;
            }
        })
        return isAssigned;
    }

    private removeScenesUsedInScenes() {
        const updatedSceneIds: Id[] = [];
        const scenes: IPlayerProps[] = this.getScenes();

        this.selection.selected.forEach((sceneId) => {
            const searchResourceResult: ISceneTreeSearchResult[] = getPlayerIdsOfSceneId(scenes, String(sceneId));

            searchResourceResult.forEach((v) => {
                let updated = false;

                if (v.lastPlaylistId) {
                    const sceneData = getPlayerIdInScene(scenes, v.sceneId, v.lastPlaylistId);
                    this.removeScenesInPlaylist(sceneData, String(sceneId));
                    updated = true;
                }
                if (v.lastLocationId) {
                    const sceneData = getPlayerIdInScene(scenes, v.sceneId, v.lastLocationId);
                    this.removeScenesInLocation(sceneData, String(sceneId), 'GPS');
                    this.removeScenesInLocation(sceneData, String(sceneId), 'Fixed');
                    updated = true;
                }

                if (!v.lastPlaylistId && !v.lastLocationId && v.o?.id) {
                    this.storeSelector.dispatch(actionRemoveSceneBlocks({
                        sceneId: v.sceneId,
                        sceneItemId: null,
                        values: [{
                            key: null,
                            value: v.o.id,
                            storePath: 'Data[0].Scene[0].Players[0].Player'
                        }]
                    }));
                    updated = true;
                }

                if (updated) {
                    if (updatedSceneIds.indexOf(String(v.sceneId)) === -1) {
                        updatedSceneIds.push(String(v.sceneId));
                    }
                }
            });
        });

        // save changes
        this.appService.updateMultiScene(updatedSceneIds);
    }

    private removeScenesUsedInScheduler() {
        /** remove scene schedule event */
        const sceneIds = this.selection.selected.map((sceneId) => String(sceneId));
        this.commonService.removeScheduleEventsBySources('scene', sceneIds);
    }

    // private removePrivateChildScenes() {
    //     let privateChildIds = [];
    //     this.selection.selected.forEach((_sceneId) => {
    //         this.storeSelector.listenPrivateChildPlayersOfScene(_sceneId).subscribe((_players: IPlayerProp[]) => {
    //             privateChildIds = privateChildIds.concat(_players.map((_player) => _player.$.src));
    //         }).unsubscribe();
    //     });

    //     if (privateChildIds.length > 0) {
    //         this.storeSelector.dispatch(actionRemoveScenes({
    //             sceneIds: privateChildIds
    //         }));
    //         this.crudScene('delete', privateChildIds, null);
    //     }
    // }

    confirmDuplicate() {
        const msg = this.translocoService.translate('message.sureDuplicate', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: {name: msg, showCancel: true}
            // data: {name: `${msg} ${this.selection.selected.length}`, showCancel: true}
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                this.onDuplicate();
            }
        });
    }

    onDuplicate() {

        this.selection.selected.forEach((i_selectedSceneId) => {
            const sceneData = _.cloneDeep(this.scenes.find((i_scene) => i_scene.Player.$.id === i_selectedSceneId));
            const saveRecord = preprocessSceneRecord(sceneData, null, this.localStoreService.getStorageConfig().studioId, 'add');

            /** create scene and get inserted id */
            this.appService.crudRecord(saveRecord).then((i_result: ICRUDRecord) => {
                const newPlayerId = String(i_result.serverReply.id);
                sceneData.Player.$.id = newPlayerId;
                sceneData.Player.$.label = `${sceneData.Player.$.label} | Copy - ${newPlayerId}`;
                sceneData.Player.$.changelist_id = String(i_result.serverReply.changelist_id);
                this.storeSelector.dispatch(actionAddScene({player: sceneData}));
                this.crudScene('update', newPlayerId, {
                    tree_path: sceneData.Player.$.folder,
                    access_key: sceneData.Player.$.accessKey
                });
                this.toastr.info("duplicated new scene with id is " + newPlayerId);
            });
        });
    }

    private resetSelection() {
        this.selection.clear();
    }

    private removeScenes(deletePrivateChild) {
        let removeSceneIds = this.selection.selected;
        if (deletePrivateChild) {
            // get ids of private child items
            let privateChildIds = [];
            this.selection.selected.forEach((_sceneId) => {
                this.storeSelector.listenPrivateChildPlayersOfScene(_sceneId).subscribe((_players: ISceneBlock[]) => {
                    privateChildIds = privateChildIds.concat(_players.map((_player) => _player.$.src));
                }).unsubscribe();
            });
            removeSceneIds = removeSceneIds.concat(privateChildIds);
        }

        this.storeSelector.dispatch(actionRemoveScenes({
            sceneIds: removeSceneIds
        }));
        this.crudScene('delete', removeSceneIds, null);
    }

    private removeScenesInPlaylist(playerSceneData: ISceneTreeSliceResults, sceneId: Id) {
        const components: ICommon = _.cloneDeep(playerSceneData.sceneItem.Data["0"]);
        _.remove(components.Playlist[0].Page, (v: IPage) => {
            if (v.$.type !== 'scene') return;
            return v.Player[0].$.src === sceneId;
        });
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: playerSceneData.sceneId,
            sceneItemId: playerSceneData.sceneItem.$.id,
            values: [{
                key: 'Page',
                value: components.Playlist[0].Page,
                storePath: `Data[0].Playlist[0]`
            }]
        }));
        this.storeSelector.dispatch({type: 'BREAK_MERGE'});
    }

    private removeScenesInLocation(playerSceneData: ISceneTreeSliceResults, sceneId: Id, slice: 'GPS' | 'Fixed') {
        const components: ICommon = _.cloneDeep(playerSceneData.sceneItem.Data["0"]);
        _.remove(components.LocationBased[0][slice][0].Page, (v: IPager) => {
            if (_.isEmpty(v)) return true;
            if (v.$.type !== 'scene') return false;
            return v.Player[0].$.src === sceneId;
        });
        const storePath = `Data[0].LocationBased[0][${slice}][0]`;
        const value = components.LocationBased[0][slice][0]['Page'];
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: playerSceneData.sceneId,
            sceneItemId: playerSceneData.sceneItem.$.id,
            values: [{
                key: 'Page',
                value,
                storePath
            }]
        }));
        this.storeSelector.dispatch({type: 'BREAK_MERGE'});
    }

    private getScenes(): IPlayerProps[] {
        let scenes: IPlayerProps[] = [];
        this.cod(
            this.storeSelector.getScenes().subscribe((i_scenes) => {
                scenes = i_scenes;
            })
        );
        return scenes;
    }

    private getStations(): IPlayerProps[] {
        let scenes: IPlayerProps[] = [];
        this.cod(
            this.storeSelector.getScenes().subscribe((i_scenes) => {
                scenes = i_scenes;
            })
        );
        return scenes;
    }

    private getSceneCategories() {
        this.cod(
            this.storeSelector.getScenes(true)
                .subscribe((i_scenes) => {
                    this.categories = [];
                    i_scenes.forEach((s, idx) => {
                        if (s.Player.$.folder) {
                            this.categories.push(s.Player.$.folder);
                        }
                    });
                    this.categories = this.categories
                        .reduce((x, y) => x.includes(y) ? x : [...x, y], [])
                        .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
                    this.containerService.setCategories(this.categories);
                })
        );
    }

    onSelectScene(sceneId) {
        var selectedScene = this.dataSource.data.find(row => row.Player.$.id == sceneId);
        this.onSelectedRow(selectedScene);
    }

    onSelectedRow(row) {
        if (isSceneEmbedded(row))
            return this.toastr.error(this.translocoService.translate('toast.embeddedScenesNo', {}, this.translocoService.getActiveLang()));
        if (this.dialogGetAsset) {
            this.itemSelected.emit(row.Player.$.id);
        } else {
            this.router.navigate([`/editor/scene/${row.Player.$.id}`]);
        }
    }

    /** clear global filter */
    clearSelection() {
        this.globalFilter = '';
        this.applyFilter('');
        this.getSceneCategories();
    }

    onChangePagination(e: PageEvent) {
        if (!e) return;
        this.pageIndex = e.pageIndex;
        if (this.selectedTabIndex === 0) {
            this.pageSize = e.pageSize;
        }
    }

    sortData(e) {
        this.activeSort = e;
    }

    private customFilterPredicate() {
        const myFilterPredicate = (data: any, filter: string): boolean => {
            let globalMatch = !this.globalFilter;

            if (this.globalFilter) {
                // search all fields
                globalMatch = (data.Player.$.label + '').toString().toLowerCase().indexOf(this.globalFilter.trim().toLowerCase()) !== -1;
            }

            if (!globalMatch) {
                return false;
            }

            const filterObj = JSON.parse(filter);
            let isFilter = true;
            // tslint:disable-next-line
            for (const col in filterObj) {
                let colData = data[col];
                if (col == 'tree_path') {
                    colData = data.Player.$?.folder;
                }
                if (typeof colData !== 'undefined' && colData.toString().toLowerCase().indexOf(filterObj[col].trim().toLowerCase()) == -1) {
                    isFilter = false;
                    break;
                }
            }
            return isFilter;
        };
        return myFilterPredicate;
    }

    private crudScene(command: ICRUDCommand, id, body) {
        const saveRecord: ICRUDRecord = {
            studioId: this.localStoreService.getStorageConfig().studioId,
            command,
            primary: 'player_data_id',
            table: 'player_data',
            body,
            id
        };
        this.storeSelector.dispatch(actionCRUDRecord({saveRecord}));
    }

    clipboardOpenDialog() {
        if (Lib.IsAccessBlocked(this.m_user)) {
            return this.toastr.error(this.translocoService.translate('account.screenDisruption', {}, this.translocoService.getActiveLang()), '[ Contact live chat ]');
        }
        if (!this.m_user.enterprise){
            this.appService.openWizardUpgradeDialog(EnumWizardUpgradeToasts.UPGRADE_TO_USE_FEATURE);
            return;
        }
        const dialogRef = this.dialog.open(DialogClipboardComponent, {
            height: '360px',
            width: '610px',
            data: {scenes: this.selection}
        });
        // this.cod(
        //     dialogRef.afterClosed()
        //         .pipe(take(1))
        //         .subscribe((dialogGetAsset: IDialogGetAsset) => {
        //         })
        // );
    }

    toggleListView(tabChangeEvent: MatTabChangeEvent) {
        this.selectedTabIndex = tabChangeEvent.index;
        if (this.selectedTabIndex === 0) {
            this.hidePageSize = false;
            this.paginator._changePageSize(this.pageSize);
        } else {
            this.hidePageSize = true;
            this.paginator._changePageSize(10);
        }
    }

    override destroy() {
        this.onDeselect();
        this.containerService.setTableSelection('scenes', {
            // selectedModel: this.selection.selected,
            sort: this.activeSort,
            pageIndex: this.pageIndex,
        });
        this.containerService.setMarkedTableRow(null);
    }
}


